import Map from "./Map";

class MapDetail extends Map {
    constructor(elem, locations) {
        super(elem, locations, 17);

        this.filterInputs = elem.querySelectorAll("input.js-map-filter");
        this.filters = [];

        this.noPoiFoundFor = [];

        this.radius = 500;
        this.maxPoi = 10;

        this.infoWindow = new window.google.maps.InfoWindow();

        this._setDOMReferences();
    }

    _setDOMReferences() {
        for (let i = 0; i < this.filterInputs.length; i++) {
            const element = this.filterInputs[i];
            element.addEventListener("change", () =>
                this.onFilterChange(element)
            );
        }
    }

    onFilterChange(element) {
        const filterVal = element.value;

        if (element.checked) {
            this.filters.push(filterVal);
        } else {
            this.filters = this.filters.filter((item) => item != filterVal);
        }

        if (this.markers.hasOwnProperty(filterVal)) {
            element.checked
                ? this.toggleMarkerGroup("show", filterVal)
                : this.toggleMarkerGroup("hide", filterVal);
        } else {
            this.markers[filterVal] = [];
            this.getFilterMarkers(filterVal);
        }
    }

    toggleMarkerGroup(toggleType, filterType) {
        const map = toggleType == "show" ? this.map : null;
        for (let i = 0; i < this.markers[filterType].length; i++) {
            const marker = this.markers[filterType][i];
            marker.setMap(map);
        }

        if (map === null) {
            this.removeMarkersFromCluster(this.markers[filterType]);
        } else {
            this.addMarkersToCluster(this.markers[filterType]);
        }
    }

    async getFilterMarkers(type) {
        // Restrict within the map viewport.
        const location = this.locations[0];
        let center = new google.maps.LatLng(location.lat, location.lng);
        const request = {
            // Required parameters.
            fields: ["displayName", "location", "formattedAddress"],
            locationRestriction: {
                center: center,
                radius: this.radius,
            },
            // Optional parameters.
            includedPrimaryTypes: [type],
            maxResultCount: this.maxPoi,
            rankPreference:
                google.maps.places.SearchNearbyRankPreference.POPULARITY,
            language: "nl-NL",
            region: "nl",
        };

        const { places } = await google.maps.places.Place.searchNearby(request);

        const self = this;

        if (places.length) {
            // Loop through and get all the results.
            places.forEach((place) => {
                self.createPoiMarker(place, type);
                self.bounds.extend(place.location);
            });
            self.map.fitBounds(self.bounds);
        } else {
            self.noPoiFoundFor.push(type);
            self.updateMessage();
        }
    }

    mapTypesToLabels(types) {
        const mapping = {
            bakery: "Bakker",
            bank: "Bank",
            bus_station: "Busstation",
            cafe: "Café",
            city_hall: "Gemeentehuis",
            museum: "Museum",
            park: "Park",
            parking: "Parkeergarage",
            hospital: "Ziekenhuis",
            restaurant: "Restaurant",
            school: "School",
            gym: "Sportschool",
            grocery_or_supermarket: "Supermarkt",
            gas_station: "Tankstation",
            taxi_stand: "Taxi",
            train_station: "Trein station",
            university: "Universiteit",
            store: "Winkel",
        };

        return types.map((type) => mapping[type] || this.capitalize(type));
    }

    capitalize(text) {
        return text
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join("");
    }

    updateMessage() {
        const span = document.querySelector(".js-filter-message");
        if (!span) return;
        if (this.noPoiFoundFor.length <= 0) {
            span.innerHTML = "";
        }

        const mappedTypes = this.mapTypesToLabels(this.noPoiFoundFor);

        span.innerHTML = `Er zijn geen reusltaten gevonden voor ${mappedTypes.join(
            ", "
        )} binnen een straal van ${this.radius} meter`;
    }

    async createPoiMarker(place, type) {
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
            "marker"
        );
        const marker = new AdvancedMarkerElement({
            map: this.map,
            position: place.location,
            title: place.displayName,
        });

        this.markers[type].push(marker);

        const self = this;

        const contentString =
            '<div class="infowindow__inner">' +
            '<div class="infowindow__address">' +
            place.formattedAddress +
            "</div>" +
            "</div>";

        const infowindow = new google.maps.InfoWindow({
            headerContent: place.displayName,
            content: contentString,
            ariaLabel: place.displayName,
        });

        marker.addListener("click", () => {
            infowindow.open({
                anchor: marker,
                map: self.map,
            });
        });
    }
}

export default MapDetail;
